import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgHeart({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 9.347c0 3.32 1.847 6.201 4.872 8.644a22.87 22.87 0 004.732 2.927l.413.178.407-.19c.083-.039.227-.11.424-.212.322-.168.68-.365 1.065-.591a24.836 24.836 0 003.224-2.245C20.157 15.364 22 12.522 22 9.348c0-5.468-5.384-7.962-9.95-5.145C7.934 1.259 2 3.929 2 9.347zm9.08 9.067a20.907 20.907 0 01-2.952-1.98C5.528 14.335 4 11.953 4 9.348c0-3.922 4.478-5.736 7.33-3.16l.609.55.658-.49C16.027 3.694 20 5.35 20 9.347c0 2.456-1.532 4.817-4.137 6.969a22.87 22.87 0 01-3.879 2.572 19.802 19.802 0 01-.904-.474z"
        fill={color}
      />
    </svg>
  )
}

export default SvgHeart
